<template>
    <v-app id="app" :class="`${!$vuetify.breakpoint.smAndDown ? 'full-sidebar' : 'mini-sidebar'}`">
      <router-view />
      <CookiesModal />
    </v-app>
</template>

<script>
import CookiesModal from '@/components/CookiesModal'

export default {
  components: { CookiesModal }
}
</script>

<style lang="scss" scoped>
.theme--dark.v-application {
  background-color: var(--v-background-base);
}
.theme--light.v-application {
  background-color: var(--v-background-base);
}
</style>
